import React from 'react'

import { Form, Col } from '_zari/core'

const InputFormGroup = ({ setFieldValue }) => {
  return (
    <Form.Group>
      <Form.Label text='ARCHIVO' htmlFor='inputfile-file' md={2} />
      <Col md={10}>
        <Form.InputFile
          id='inputfile-file'
          name='file'
          onChange={e => {
            setFieldValue('file', e.currentTarget.files[0])
          }}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(InputFormGroup)
